module.exports = __webpack_public_path__ + "static/media/38-1.3b84eec5.mp3";